import { trpc } from '@/shared/api';

interface OrderDetailQueryOptions {
  readonly enabled?: boolean;
}

/** 어드민 주문 상세(orderManagement.get, 주문 설계 §8-6) — 고객·주문 내용·결제·배송지·송장·지연·취소 요청 이력. */
export const useOrderDetailQuery = (orderId: string, options: OrderDetailQueryOptions = {}) =>
  trpc.orderManagement.get.useQuery(
    { orderId },
    {
      enabled: options.enabled ?? true,
      // 없는 주문(ORDER_NOT_FOUND)은 재시도해도 같다.
      retry: false,
    },
  );
